<template>
  <div>
    <div class="text-muted">{{ $t('customer_assessment_terms_ui.vehicle_issue_terms_help')}}</div>
    <div>
      <customer-assessment-terms :customer="customer" category="vehicle" :defaultTerms="defaultTerms" @saved="handleSave($event)"></customer-assessment-terms>
    </div>
  </div>
</template>

<script>
import CustomerAssessmentTerms from '@/components/customer/CustomerAssessmentTerms'

import { each } from 'lodash'

export default {
  name: 'VehicleIssueTerms',
  components: {
    CustomerAssessmentTerms
  },
  props: {
    customer: Object
  },
  data () {
    return {
      isReady: false,
      customerAssessmentTerms: []
    }
  },
  methods: {
    handleSave (terms) {
      this.$store.dispatch(
        'globalMessagingModule/showSuccessFlashBanner',
        `${this.$i18n.tc('vehicle_issue_terms', 2)} ${this.$i18n.t('generic_save_success')}`
      )
    }
  },
  computed: {
    defaultTerms () {
      const terms = [
        {
          type: 'action',
          value: 'Vehicle Issue Placeholder Action',
          locked: true
        },
        {
          type: 'action',
          value: 'Vehicle Issue Placeholder Action 2'
        },
        {
          type: 'cause',
          value: 'Vehicle Issue Placeholder Cause',
          locked: true
        },
        {
          type: 'cause',
          value: 'Vehicle Issue Placeholder Cause 2'
        }
      ]

      each(terms, term => {
        term.customer_id = this.customer.id
        term.category = 'vehicle'
      })

      return terms
    }
  }
}
</script>

<style scoped>
</style>
